// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"60b20220","120":"9f4a32b7","262":"441868e8","957":"e4096922"}[chunkId] + ".chunk.css";
};